import styled from '@emotion/styled';
import { rem } from 'polished';
import { Flex } from '@chakra-ui/react';

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
